/* Sunkissed custom (Oct 7 2026, "one look, two doors"): set product pages.
   - No size preselected: the shopper picks a top size and a bottom size (two rows with thumbnails).
   - Add button reads "Pick top size" / "Pick bottom size" until both are picked, then "Add set · S / M".
   - The picked pair is mapped to the matching bundle variant before the theme adds it.
   - "Just the top · $79" / "Just the bottom · $79" links to the matching single pieces (hidden if no match).
   - Oct 12 2026: prices show in the shopper's own currency (window.SK_INTL, snippets/sk-intl.liquid). */
(function () {
  'use strict';
  var page = document.querySelector('.product__page');
  if (!page) return;
  var tEl = page.querySelector('.product__title [data-zoom-caption]') || page.querySelector('.product__title');
  var title = tEl ? tEl.textContent.replace(/\s+/g, ' ').trim() : '';
  if (!/\sSet\b/.test(title)) return;
  var handle = (location.pathname.match(/\/products\/([a-z0-9-]+)/i) || [])[1];
  if (!handle) return;

  function q(s, r) { return (r || page).querySelector(s); }
  function money(c) { if (window.SK_INTL) return SK_INTL.money(c); var v = c / 100; return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fetchJson(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function imgUrl(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function pieceOf(t) { if (/\bbottom\b/i.test(t)) return 'bottom'; if (/\btop\b/i.test(t)) return 'top'; return null; }
  function colorOf(t) { var i = t.lastIndexOf(' - '); return i > -1 ? t.slice(i + 3).trim().toLowerCase() : ''; }
  function fam(t) { if (/sporty/i.test(t)) return 'sporty'; if (/triangle/i.test(t)) return 'triangle'; if (/bandeau|strapless|cheeky|\bbas\b/i.test(t)) return 'bandeau'; return ''; }
  var WORDS = { triangle: { top: 'Triangle Top', bottom: 'Triangle Bottom' }, sporty: { top: 'Sporty Top', bottom: 'Sporty Bottom' }, bandeau: { top: 'Bandeau Strapless Top', bottom: 'Bas Cheeky Bottom' } };

  // Option rows: the wrapper whose option name says "bottom" is the bottom row, "top" the top row
  var rows = {};
  Array.prototype.forEach.call(page.querySelectorAll('.product__selectors .selector-wrapper'), function (w) {
    var n = q('.radio__legend__option-name', w); var name = n ? n.textContent.trim() : '';
    var p = pieceOf(name); if (p && !rows[p]) rows[p] = { el: w, name: name, pos: parseInt(w.getAttribute('data-option-position'), 10) };
  });
  if (!rows.top || !rows.bottom) return;
  page.classList.add('sk-setpage');

  var state = { prod: null, top: null, bottom: null, pieces: {} };
  function radios(p) { return Array.prototype.slice.call(rows[p].el.querySelectorAll('input[type="radio"]')); }
  function picked(p) { var r = radios(p).filter(function (x) { return x.checked; })[0]; return r ? r.value : null; }
  function addBtn() { return q('form[action*="/cart/add"] [data-add-to-cart]'); }
  function idInput() { return q('form[data-product-form] input[name="id"]') || document.querySelector('.product__page input[name="id"][form^="ProductForm"]'); }
  function variant() {
    if (!state.prod || !state.top || !state.bottom) return null;
    return (state.prod.variants || []).filter(function (v) { return v['option' + rows.top.pos] === state.top && v['option' + rows.bottom.pos] === state.bottom; })[0] || null;
  }

  // 1. Clear the theme's XS / XS preselection, except on a ?variant= link (an explicit choice is kept)
  if (/[?&]variant=\d+/.test(location.search)) { state.top = picked('top'); state.bottom = picked('bottom'); }
  else radios('top').concat(radios('bottom')).forEach(function (r) { r.checked = false; r.removeAttribute('checked'); });

  // 2. Row headers (thumbnail + "Top size" + hint), replacing the theme legends
  ['top', 'bottom'].forEach(function (p) {
    var h = document.createElement('div');
    h.className = 'sk-srow'; h.setAttribute('data-sk-srow', p);
    h.innerHTML = '<span class="sk-srow__img" data-sk-srow-img hidden></span><span class="sk-srow__txt"><span class="sk-srow__t">' + (p === 'top' ? 'Top' : 'Bottom') + ' size<b data-sk-srow-val></b></span><small class="sk-srow__hint" data-sk-srow-hint>Pick your size</small></span>';
    rows[p].el.classList.add('sk-srow-wrap');
    rows[p].el.insertBefore(h, rows[p].el.firstChild);
  });

  // 3. Links under the button
  var links = document.createElement('div');
  links.className = 'sk-justlinks'; links.setAttribute('data-sk-justlinks', ''); links.hidden = true;
  var btnBlock = q('.product__block--buttons');
  if (btnBlock) btnBlock.parentNode.insertBefore(links, btnBlock.nextSibling);

  function paint() {
    ['top', 'bottom'].forEach(function (p) {
      var h = q('[data-sk-srow="' + p + '"]'); if (!h) return;
      var v = picked(p);
      q('[data-sk-srow-val]', h).textContent = v ? ' · ' + v : '';
      q('[data-sk-srow-hint]', h).hidden = !!v || (p === 'bottom' && !picked('top'));
    });
    var btn = addBtn(); if (!btn) return;
    var txt = btn.querySelector('[data-add-to-cart-text]'); if (!txt) return;
    var t = picked('top'), b = picked('bottom');
    var v = variant() || (state.prod && state.prod.variants && state.prod.variants[0]);
    var price = v ? money(v.price) : '';
    var label, wait = !(t && b);
    if (!t) label = 'Pick top size'; else if (!b) label = 'Pick bottom size'; else label = 'Add set · ' + t + ' / ' + b;
    var vv = variant();
    if (!wait && vv && !vv.available) { label = 'Sold out · ' + t + ' / ' + b; wait = true; }
    var html = esc(label) + '<span class="btn__price" data-product-price>' + price + '</span>';
    if (txt.innerHTML !== html) txt.innerHTML = html;
    btn.classList.toggle('sk-btn-wait', wait);
    document.documentElement.classList.toggle('sk-need-size', wait);
  }

  // Theme listens to option changes; hold them back until both sizes are picked
  document.addEventListener('change', function (e) {
    var r = e.target; if (!r || r.type !== 'radio') return;
    var p = rows.top.el.contains(r) ? 'top' : rows.bottom.el.contains(r) ? 'bottom' : null; if (!p) return;
    state[p] = r.value;
    if (!picked('top') || !picked('bottom')) e.stopPropagation();
    setTimeout(function () { syncId(); paint(); }, 30);
  }, true);
  document.addEventListener('theme:variant:change', function () { setTimeout(function () { syncId(); paint(); }, 40); });

  function syncId() { var v = variant(), i = idInput(); if (v && i && String(i.value) !== String(v.id)) i.value = v.id; }
  function scrollToRows(p) {
    var h = q('[data-sk-srow="' + p + '"]') || rows.top.el;
    window.scrollTo({ top: h.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    h.classList.remove('sk-flash'); void h.offsetWidth; h.classList.add('sk-flash');
  }

  // Add button: blocked until both sizes are picked; the pair always maps to its bundle variant.
  // On window (capture) so a blocked tap never reaches the bag toast's optimistic "Added" listener.
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product__page form[action*="/cart/add"] [data-add-to-cart]');
    if (!btn) return;
    var t = picked('top'), b = picked('bottom'), v = variant();
    if (!t || !b || !v || !v.available) {
      e.preventDefault(); e.stopImmediatePropagation();
      scrollToRows(!t ? 'top' : 'bottom');
      return;
    }
    syncId();
  }, true);

  function findPiece(want) {
    var color = colorOf(title), f = fam(title);
    var words = (WORDS[f] && WORDS[f][want]) || want;
    return fetchJson('/search/suggest.json?q=' + encodeURIComponent(words + ' ' + color) + '&resources[type]=product&resources[limit]=10').then(function (r) {
      var list = (r && r.resources && r.resources.results && r.resources.results.products) || [];
      var hit = list.filter(function (p) { var t = p.title || ''; return pieceOf(t) === want && !/\bset\b/i.test(t) && colorOf(t) === color && (!f || fam(t) === f); })[0];
      return hit ? fetchJson('/products/' + hit.handle + '.js') : null;
    });
  }

  function paintPieces() {
    var html = [];
    ['top', 'bottom'].forEach(function (p) {
      var pr = state.pieces[p]; if (!pr) return;
      var img = imgUrl(pr.featured_image || (pr.images && pr.images[0]) || '', 160);
      var slot = q('[data-sk-srow="' + p + '"] [data-sk-srow-img]');
      if (slot && img) { slot.innerHTML = '<img src="' + img + '" alt="" loading="lazy">'; slot.hidden = false; }
      var min = Math.min.apply(null, (pr.variants || []).map(function (v) { return v.price; }));
      html.push('<a class="sk-justlinks__a" href="/products/' + pr.handle + '">Just the ' + p + ' · ' + money(isFinite(min) ? min : pr.price) + '</a>');
    });
    links.innerHTML = html.join('');
    links.hidden = !html.length;
  }

  paint();
  Promise.all([fetchJson('/products/' + handle + '.js'), findPiece('top'), findPiece('bottom')]).then(function (r) {
    state.prod = r[0]; state.pieces.top = r[1]; state.pieces.bottom = r[2];
    paint(); paintPieces();
  });
  window.skSetPage = { picked: function () { return { top: picked('top'), bottom: picked('bottom') }; }, variant: variant };
})();
